// extracted by mini-css-extract-plugin
module.exports = {"result_container":"expresult_result_container__2AsWP","result_content":"expresult_result_content__3MRk5"};